<template>
  <div>
    <!-- 头像 -->
    <div class="btn">
      <el-dropdown
        @click="handleClick"
        class="avatar-container right-menu-item hover-effect"
      >
        <div class="avatar-wrapper">
          {{ user.name }}
          <i class="el-icon-arrow-down el-icon--right"></i>
          <!-- <i class="el-icon-caret-bottom"></i> -->
        </div>
        <el-dropdown-menu slot="dropdown" class="drop">
          <span style="display: block" @click="show = true">
            <el-dropdown-item>
              {{ $t("routers.LayoutSettings") }}
            </el-dropdown-item>
          </span>
          <span @click="userCenter">
            <el-dropdown-item>{{
              $t("routers.personCenter")
            }}</el-dropdown-item>
          </span>

          <span style="display: block" @click="out">
            <el-dropdown-item divided>{{
              $t("routers.loginOut")
            }}</el-dropdown-item>
          </span>
          <span style="display: block" @click="setGuide">
            <el-dropdown-item divided> 新手指导 </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 全屏缩放 -->
    <div v-if="this.mobile" class="Full-Screan">
      <img
        :src="this.ScreenImg"
        style="height: 15px; weight: 15px; vertical-align: middle"
        @click="click"
      />
    </div>
    <!-- 语言设置 -->
    <!-- class="avatar-container right-menu-item hover-effect" -->
    <div class="lang">
      <!-- <el-dropdown @command="handleClick">
        <div class="avatar-wrapper">
          <img
            :src="this.img"
            style="height: 25px; weight: 25px; vertical-align: middle"
          />
        </div>
        <el-dropdown-menu slot="dropdown" class="drop">
          <span style="display: block">
            <el-dropdown-item
              v-for="item in languageList"
              :key="item.index"
              :command="item"
            >
              <img
                :src="require('../../../assets/LangImg/' + item + '.png')"
                style="height: 25px; weight: 25px; vertical-align: middle"
              />
            </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown> -->
      <el-dropdown @command="handleClick">
        <div class="avatar-wrapper">
          {{ this.language }}
        </div>
        <el-dropdown-menu slot="dropdown" class="drop">
          <span style="display: block">
            <el-dropdown-item
              v-for="item in languageList"
              :key="item.index"
              :command="item"
              :value="item.language"
              v-if="item.enable"
            >
              {{ item.name }}
            </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 主题选择 -->
    <!-- <div>
      <select v-model="color" :placeholder="$t('placeholder.selectPlaceholder')" @change="changeColor">
        <option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></option>
      </select>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ScreenImg from "@/assets/screen/全屏.png";
import screenfull from "screenfull";
import ScreenImg2 from "@/assets/screen/取消全屏.png";
import { getToken, setLang, getLang } from "@/utils/auth/";
import { changeLange } from "@/utils/i18n";
import { getMenusFile } from "@/router/getMenus";
import { resetRouter } from "@/router/routers";
// import { getRoutes } from "vue-router";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["sidebar", "user"]),
  },
  created() {
    if (!getLang()) {
      setLang(navigator.language);
      this.$i18n.locale = "CN";
    } else {
      this.languageCheck(getLang());
    }
  },
  mounted() {
    this.IsPC();
    window.document.documentElement.setAttribute("data-theme", this.color);
    this.changeColor();
    this.$store.commit("SET_THEME", this.color);
    this.getLanguageSet();
  },
  data() {
    return {
      mobile: "",
      // img: img,
      name: "",
      isCollapse: true,
      isShow1: true,
      isShow2: false,
      ScreenImg: ScreenImg,
      screenfull: false,
      color: "green",
      img: require("../../../assets/LangImg/多语言.png"),
      options: [
        {
          value: "green",
          label: "绿色",
        },
        {
          value: "blue",
          label: "蓝色",
        },
      ],
      languageList: [],
      language: "",
    };
  },
  methods: {
    setGuide() {
      // 通过id或者class绑定步骤，也可以直接定死在div上面
      // let steps = [
      //   {
      //     element: ".item1",
      //     intro: "步骤1:对应class为.step_1的元素进行选择提示!",
      //     // position: "right",
      //   },
      //   {
      //     element: ".item2",
      //     intro: "步骤2:对应Id为#step_2的元素进行选择提示!",
      //     // position: "left",
      //   },
      // ];

      //引入intro.js
      // var introJS = require("intro.js");
      // console.log(introJS, "introJS");

      introJs()
        .setOptions({
          // 我给看的效果图是英文的（默认英文），这里是更换成中文
          prevLabel: this.$t("map.intro.prevLabel"),
          nextLabel: this.$t("map.intro.nextLabel"),
          skipLabel: this.$t("map.intro.skipLabel"),
          doneLabel: this.$t("map.intro.doneLabel"),
          // steps步骤，可以写个工具类保存起来
          // steps: steps,
        })
        .oncomplete(() => {
          // 需要注意的是，这里用了箭头函数
          // 点击结束按钮后执行的事件
          // localStorage.setItem("isFirst", false);
        })
        .onexit(() => {
          // 点击跳过按钮后执行的事件
        })
        .onbeforeexit(() => {
          // 确认完毕之后执行的事件
          // return confirm('Are you sure?')
        })
        .start();
    },
    // 本地语言判定
    languageCheck(val) {
      if (val == "zh-CN") {
        this.$i18n.locale = "CN";
      }
      if (val == "zh-HK") {
        this.$i18n.locale = "HK";
      }
      if (val == "en") {
        this.$i18n.locale = "en";
      }
      if (val == "ja") {
        this.$i18n.locale = "ja";
      }
    },
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
    async handleClick(val) {
      console.log(val, "val");
      await resetRouter();
      await changeLange(val.language).then(() => {
        this.language = val.name;
        console.log(this.language, "this.language");
        this.$store.dispatch("setLanguage", val.language);
        this.languageCheck(val.language);
        this.$store.dispatch("GetInfo");
        getMenusFile(this.$store.state.permission.addRouters).then((res) => {
          let path = this.$route.fullPath;
          this.$router.push({ path: path }).catch((data) => {});
          this.$router.addRoutes(res);
          this.$store.dispatch("clearVisitedView", this.$route);
        });
      });

      // this.reload();
    },

    // 获得语言
    getLanguageSet() {
      this.$http.language.getLanguageSet().then((res) => {
        this.languageList = res.datas;
        this.languageList.forEach((item) => {
          console.log(getLang(), " getLang()");
          if (item.language == getLang()) {
            this.language = item.name;
            console.log(this.language);
          }
        });
      });
    },
    //     // 修改语言

    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    out() {
      // console.log(getToken());
      this.$confirm(this.$t("routers.tipsContent"), this.$t("routers.tips"), {
        confirmButtonText: this.$t("publicFile.button.confirm"),
        cancelButtonText: this.$t("publicFile.button.cancel"),
        type: "warning",
      }).then(() => {
        this.logOut();
      });
    },
    async logOut() {
      let res = await this.$store.dispatch("LogOut");
      //  .then((res) => {
      if (res.code == 200) {
        this.$message({
          message: this.$t("routers.logoutSuccess"),
          type: "success",
        });
        location.reload();
      } else if (res.code == 500) {
        this.$message.error(this.$t("routers.logoutFall"));
      }
    },
    userCenter() {
      this.$router.push({ path: "/center" }).catch((err) => {});
    },
    click() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: "you browser can not work",
          type: "warning",
        });
        return false;
      }
      if (screenfull.isFullscreen) {
        this.ScreenImg = ScreenImg;
      } else {
        this.ScreenImg = ScreenImg2;
      }
      this.fullscreen;
      screenfull.toggle();
    },
    // 修改颜色
    changeColor() {
      this.$store.commit("SET_THEME", this.color);
      window.document.documentElement.setAttribute("data-theme", this.color);
    },
  },
  watch: {},
};
</script>

<style>
/* .icon{
  float: left;
  height: 50px;
  font-size: 25px;
  margin-right: 20px;
  background-color: #fff;
} */
/* .icon i{
  margin-top: 25%;
} */
.user {
  float: right;
}
.avatar-container {
  margin-right: 0px;
}
.avatar-container .avatar-wrapper {
  margin-top: 5px;
  position: relative;
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;
}
.right-menu-item .hover-effect {
  cursor: pointer;
  transition: background 0.3s;
}
.menu {
  padding: auto;
  float: left;
  height: 100%;
  font-size: 40px;
  margin: 20px 0 0 0px;
}
.btn {
  float: right;
  height: 100%;
  font-size: 40px;
  vertical-align: middle;
}
/* .btn el-dropdown {
  top: 26%;
} */
.avatar-container {
  margin-right: 30px;
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;
}
.hover-effect {
  cursor: pointer;
  transition: background 0.3s;
}
.avatar-wrapper {
  margin-top: 5px;
  position: relative;
}
.el-icon-caret-bottom {
  cursor: pointer;
  position: absolute;
  right: -20px;
  top: 25px;
  font-size: 12px;
}
.lang {
  float: right;
  display: inline-block;
  margin-right: 10px;
}
.Full-Screan {
  float: right;
  margin-right: 10px;
  vertical-align: middle;
  margin-top: 5px;
  position: relative;
}
.drop {
  width: 100px;
}
</style>
